import endOfDay from "date-fns/endOfDay";
import isAfter from "date-fns/isAfter";
import isBefore from "date-fns/isBefore";
import startOfDay from "date-fns/startOfDay";
import subMonths from "date-fns/subMonths";
import subYears from "date-fns/subYears";
import * as yup from "yup";

export type AiAssistantKarteGenerationFormValues = {
  aiAssistantTemplateId: number | null;
  startDate: Date;
  endDate: Date;
};

const validationSchema = yup.object({
  aiAssistantTemplateId: yup.number().nullable().defined(),
  startDate: yup
    .date()
    .required()
    .test(
      "withinOneYear",
      "開始日は本日から1年以内を指定してください",
      (value) => {
        if (!value) {
          return true;
        }
        return !isBefore(value, startOfDay(subYears(new Date(), 1)));
      },
    )
    .test(
      "withinThreeMonths",
      "期間は3ヶ月以内で指定してください",
      function (value) {
        if (!value) {
          return true;
        }
        const endDate = this.parent.endDate as Date | undefined;
        if (!endDate) {
          return true;
        }
        const threeMonthsBeforeEnd = subMonths(endDate, 3);
        return !isBefore(value, threeMonthsBeforeEnd);
      },
    ),
  endDate: yup
    .date()
    .required()
    .test(
      "notFuture",
      "終了日は本日以前を指定してください",
      (value) => !value || !isAfter(value, endOfDay(new Date())),
    )
    .min(yup.ref("startDate"), "終了日は開始日以降を指定してください"),
});

export default validationSchema;
